import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import '@fortawesome/fontawesome-free/css/all.css';
import TestController from './controllers/TestController';
import PlayerEmitter from './event/PlayerEmitter';
import VueCookies from 'vue-cookies';
import ToolManager from './controllers/tools/ToolManager';
import ToolDisplayManager from './components/tools/ToolDisplayManager';
import { createI18n } from 'vue-i18n';
import en from './i18n/lang/en.json';
import es from './i18n/lang/es.json';
import fi from './i18n/lang/fin.json';
import swe from './i18n/lang/swe.json';
import es_mx from './i18n/lang/es-mx.json';

const app = createApp(App);

app.use(VueCookies);
app.use(store);
app.use(router);

// Internationalization
let lang = window.navigator.language;
if (lang == 'en-US') {
  lang = 'en';
}

const languages = {
  en: en,
  es: es,
  fi: fi,
  sv: swe,
  'es-MX': es_mx,
};
const messages = Object.assign(languages);
const i18n = createI18n({
  locale: lang,
  fallbackLocale: 'en',
  silentTranslationWarn: true,
  messages,
});
app.use(i18n);

const emitter = new PlayerEmitter();
app.provide('testController', new TestController(process.env.VUE_APP_SERVICE_URL, emitter));
app.provide('playerEmitter', emitter);
app.provide('toolManager', new ToolManager());
app.provide('toolDisplayManager', new ToolDisplayManager());

app.config.globalProperties.window = window;
app.config.globalProperties.window.i18n = i18n;

app.mount('app');
